import React from "react";
import { NavLink, Outlet, Link, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { House, Calendar, ClipboardText, Newspaper, EnvelopeSimple, ChartLineUp, PaperPlaneTilt, QrCode, SignOut } from "@phosphor-icons/react";

const AdminLayout = () => {
  const { admin, logout, bootLoading } = useAuth();
  if (bootLoading) return <div className="p-12 font-mono-tech text-white/40">/ booting admin...</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  if (admin.role === "door") return <Navigate to="/checkin" replace />;

  return (
    <div className="min-h-screen grid grid-cols-12 bg-cyber-black cyber" data-testid="admin-layout">
      <aside className="col-span-12 lg:col-span-2 border-r border-cyber-line lg:min-h-screen flex lg:flex-col print:hidden">
        <div className="p-5 border-b border-cyber-line lg:border-b-0 flex items-center justify-between lg:block">
          <Link to="/" className="font-mono-tech text-cyber-yellow text-xs tracking-[0.3em]">FINTECHOMNI</Link>
          <div className="font-mono-tech text-[10px] text-white/40 mt-1 hidden lg:block">/ admin terminal</div>
        </div>
        <nav className="flex lg:flex-col flex-row overflow-x-auto lg:overflow-visible">
          <NavItem to="/admin" icon={<House size={14} />} label="Dashboard" end testid="nav-dashboard" />
          <NavItem to="/admin/analytics" icon={<ChartLineUp size={14} />} label="Analytics" testid="nav-analytics" />
          <NavItem to="/admin/events" icon={<Calendar size={14} />} label="Events" testid="nav-events-admin" />
          <NavItem to="/admin/rsvps" icon={<ClipboardText size={14} />} label="RSVPs" testid="nav-rsvps" />
          <NavItem to="/admin/broadcasts" icon={<PaperPlaneTilt size={14} />} label="Broadcasts" testid="nav-broadcasts" />
          <NavItem to="/admin/news" icon={<Newspaper size={14} />} label="News" testid="nav-news-admin" />
          <NavItem to="/admin/contacts" icon={<EnvelopeSimple size={14} />} label="Inbox" testid="nav-contacts-admin" />
          <NavItem to="/admin/agreements" icon={<EnvelopeSimple size={14} />} label="Contracts" testid="nav-agreements-admin" />
          <NavItem to="/checkin" icon={<QrCode size={14} />} label="Check-in" testid="nav-checkin" end={false} />
        </nav>
        <div className="mt-auto p-5 border-t border-cyber-line hidden lg:block">
          <div className="text-white/50 font-mono-tech text-xs truncate" data-testid="admin-current-email">{admin.email}</div>
          <button onClick={logout} data-testid="admin-logout-btn" className="mt-3 flex items-center gap-2 font-mono-tech text-xs uppercase tracking-[0.2em] text-cyber-red hover:text-white transition-colors">
            <SignOut size={12} /> Log out
          </button>
        </div>
      </aside>
      <main className="col-span-12 lg:col-span-10 p-5 sm:p-10 print:col-span-12 print:p-0 print:bg-white">
        <Outlet />
      </main>
    </div>
  );
};

const NavItem = ({ to, icon, label, end, testid }) => (
  <NavLink
    to={to}
    end={end}
    data-testid={testid}
    className={({ isActive }) =>
      `flex items-center gap-3 px-5 py-4 font-mono-tech text-xs uppercase tracking-[0.2em] border-b border-cyber-line lg:border-b-0 lg:border-l-2 transition-all duration-150
      ${isActive ? 'bg-cyber-elevated text-cyber-yellow lg:border-l-cyber-yellow' : 'text-white/60 lg:border-l-transparent hover:text-white hover:bg-cyber-surface'}`
    }
  >
    {icon} {label}
  </NavLink>
);

export default AdminLayout;
